import styled from 'styled-components';

export const InsightsIconContainer = styled.button`
  display: flex;
  position: relative;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    transform: scale(1.25);
  }

  &:disabled {
    pointer-events: none;
  }
`;

export const ScenarioIconWrapper = styled.div`
  display: inline-flex;
`;
